import { aiQuestionType } from '~/types/ai-summary.type'
import { ITab } from '~/types/tab.type'

export const BLOCK_AI_QUESTION_LIST: Array<ITab<aiQuestionType>> = [
  {
    label: 'Summary of this block',
    value: aiQuestionType.SUMMARY
  }
]

export const TRANSACTION_AI_QUESTION_LIST: Array<ITab<aiQuestionType>> = [
  {
    label: 'Summary of this transaction',
    value: aiQuestionType.SUMMARY
  }
]